// @flow

export default class {
  coefficient: number;

  constructor(coefficient: number) {
    this.coefficient = coefficient === undefined ? 0.005 : coefficient;
  }

  calculate(value: number): number {
    return 1 - Math.pow(Math.E, -this.coefficient * value);
  }

  judge(value: number): boolean {
    return Math.random() < this.calculate(value);
  }

  getString(): string {
    return `1 - e<sup>${-this.coefficient}x</sup>`;
  }

  getSampleData(start: number, end: number): Array<number> {
    const results = [];
    for (let i = start; i <= end; i++) {
      results.push(this.calculate(i));
    }
    return results;
  }
}



// WEBPACK FOOTER //
// ./src/lib/condition/prey_condition.js